import { backdropClasses } from '@ahamove/web-components/lib/Backdrop';
import Button from '@ahamove/web-components/lib/Button';
import { buttonBaseClasses } from '@ahamove/web-components/lib/ButtonBase';
import Dialog, { dialogClasses } from '@ahamove/web-components/lib/Dialog';
import DialogActions from '@ahamove/web-components/lib/DialogActions';
import DialogContent from '@ahamove/web-components/lib/DialogContent';
import DialogContentText from '@ahamove/web-components/lib/DialogContentText';
import DialogTitle from '@ahamove/web-components/lib/DialogTitle';
import Dock from '@ahamove/web-components/lib/Dock';
import { useTranslation } from 'next-i18next';
import { homeConfig } from '@/modules/home/homeConfig';

type Props = {
  address?: string;
  open: boolean;
  onClose: () => void;
};

export default function NoServiceModal({ address = '', open, onClose }: Props) {
  const { t } = useTranslation(homeConfig.i18nNamespaces);

  return (
    <Dialog
      maxWidth="xs"
      fullWidth
      open={open}
      sx={{
        [`.${backdropClasses.root}`]: {
          bgcolor: 'rgba(0, 0, 0, 0.35)',
        },
        [`.${dialogClasses.paper}`]: {
          maxWidth: 343,
          mx: '0px !important',
          pb: 0,
          borderRadius: 3,
          boxShadow: '9px 27px 32px rgba(8, 26, 61, 0.1)',
          overflow: 'hidden',
          overflowY: 'auto',

          [`> .${buttonBaseClasses.root}`]: {
            display: 'none',
          },
        },
      }}
    >
      <DialogTitle id="scroll-dialog-title">
        {t('booking:location.service_unavailable')}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          <span
            dangerouslySetInnerHTML={{
              __html: t('booking:location.service_unavailable_desc', {
                address,
              }),
            }}
          />
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Dock>
          <Button onClick={onClose} data-test-id="closeNoServiceModal">
            {t('common:got_it')}
          </Button>
        </Dock>
      </DialogActions>
    </Dialog>
  );
}
